import React from 'react';
import { useHistory } from 'react-router-dom';


// @material-ui/core
import { Box, Typography, Divider, TextField, Button, Card, InputBase, Icon, ButtonBase ,ButtonGroup,Radio,FormControlLabel,RadioGroup,FormLabel,FormControl, Dialog, DialogTitle, DialogContent, DialogActions, CircularProgress, Backdrop} from '@material-ui/core'

// core components
import CatalogsTablePage from '../CatalogsTablePage';
import BundleBody from './BundleBody';

// @redux
import Add from '@material-ui/icons/Add';

// @local
import { useStyles } from '../../../../assets/styles/jss/pages/microcredentials/useStyles';




function NewRequestButton({ setRequest, setOpenModal, setModalData }) {
  const classes = useStyles();
  
  const onClickOption = () => {
    // Inicializa formulario vacío para crear
    const newRequest = {
      workflow: [],
      form: { id: null, ou: "", name: "", description: "" }
    };
    setRequest(newRequest);
    setModalData(newRequest);
    setOpenModal(true); // Abrir modal en lugar de navegar
  };

  return (
    <Button
      onClick={onClickOption}
      startIcon={<Add />}
      className={classes.buttonCrear}
      variant="contained"
    >
      Crear Bundle
    </Button>
  );
}


const Bundle = () => {
  const classes = useStyles();
  const history = useHistory();
  const [request, setRequest] = React.useState({});
  const [state, setState] = React.useState({
    canReadWrite: true,
  });
  
  // Estados para el modal
  const [openModal, setOpenModal] = React.useState(false);
  const [modalData, setModalData] = React.useState(null);
  const [refreshTable, setRefreshTable] = React.useState(0);
  const [isLoading, setIsLoading] = React.useState(false);

  // Debug: verificar cambios en isLoading
  React.useEffect(() => {
    console.log('isLoading cambió a:', isLoading);
  }, [isLoading]);

  return (
    <Box>

<Box mb={3}>
           <Typography variant="h1" component="h1" gutterBottom>
             Bundles
           </Typography>
           <Typography variant="h6" component="h2" color="textSecondary" className={classes.catalogoSubtitulo}>
             Todos los bundles
           </Typography>
         </Box>

      {/* Container*/}
        <Box style={{ width: '100%', padding: '20px', backgroundColor: '#1c1f24', borderRadius: '10px' }}>
        
        {/* Header con botón de crear */}
        <Box display="flex" justifyContent="flex-end" mb={2}>
          {state.canReadWrite && (
            <NewRequestButton 
              setRequest={setRequest} 
              setOpenModal={setOpenModal}
              setModalData={setModalData}
            />
          )}
        </Box>
        
        <Divider style={{ width: '100%', marginBottom: '50px', borderBottom: '1px solid #A0A9BA' }} />
        
        {/* Tabla de bundles */}
        <CatalogsTablePage
          key={refreshTable} // Forzar re-render cuando cambie
          canReadWrite={state.canReadWrite}
          catalogType="bundle"
          setRequest={setRequest} 
          history={history}
          refreshTrigger={refreshTable} // Prop adicional para forzar refresh
          onEditItem={(formData) => {
            setModalData({ form: formData });
            setOpenModal(true);
          }}
        />
      </Box>

      {/* Modal para crear/editar Bundle */}
      <Dialog 
        open={openModal} 
        onClose={() => setOpenModal(false)}
        maxWidth="md"
        fullWidth
        className={classes.modalDialog}
        PaperProps={{
          style: {
            backgroundColor: '#1c1f24',
            borderRadius: '12px',
            border: '1px solid #333',
            boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
          }
        }}
      >
        <DialogTitle className={classes.modalTitle}>
          <Typography variant="h6" style={{ color: '#9F6FFB', fontWeight: 600 }}>
            {modalData?.form?.id ? 'Editar Bundle' : 'Crear Bundle'}
          </Typography>
        </DialogTitle>
        <DialogContent className={classes.modalContent}>
          <BundleBody 
            readOnly={false}
            onClose={() => setOpenModal(false)}
            onSuccess={() => {
              setOpenModal(false);
              setRefreshTable(prev => prev + 1); // Actualizar tabla
            }}
            onLoadingChange={setIsLoading} // Pasar función para controlar loading
            formData={modalData?.form}
          />
        </DialogContent>
      </Dialog>

      {/* Spinner de carga - FUERA del modal */}
      <Backdrop className={classes.backdrop} open={isLoading}>
        <Box className={classes.spinner}>
          <CircularProgress color="inherit" size={60} />
          <Typography className={classes.spinnerText}>
            Guardando bundle...
          </Typography>
        </Box>
      </Backdrop>
    </Box>
  );
};

export default Bundle;
